<template>
  <div id="app" class="wrapper">
    <div class="content-wrapper" style="overflow: visible" ref="topo">
      <section class="content-header">
        <div
          style="padding-right: 0px; padding-left: 0px; overflow: visible"
          class="container-fluid"
        ></div>
      </section>

      <section
        class="content"
        style="
          font-family: Roboto, -apple-system, Helvetica Neue, Helvetica, Arial,
            sans-serif;
        "
      >
        <div
          style="padding-right: 0px; padding-left: 0px"
          class="container-fluid"
        >
          <div class="form-group">
            <div id="app">
              <div class="div_banner-cabecalho">
                <img
                  class="banner"
                  v-bind:src="
                    'https://apppanterafood.com.br/DeliCenter/' +
                    retornaContrato +
                    '/logo/topo_deli.jpg'
                  "
                />

                <div class="cabecalho_restaurante">
                  <div>
                    <img
                      class="imagem_logotipo"
                      src="https://cdn-icons-png.flaticon.com/512/7723/7723742.png"
                    />
                  </div>

                  <div class="informacoes_restaurante">
                    <h1 class="nome_restaurante">{{ estabelecimento.vl }}</h1>

                    <div style="display: flex; flex-direction: column">
                      <p class="dados_restaurante">
                        Endereço: {{ endereco.vl }}
                      </p>
                      <p
                        class="dados_restaurante"
                        v-for="(horario, index) in horarios"
                        :key="index"
                      >
                        {{ horario.hr_inicial }} às {{ horario.hr_final }} /
                        {{ retornaDias(index) }}
                      </p>
                      <div
                        style="
                          display: flex;
                          flex-direction: column;
                          gap: 0.03em;
                          justify-content: flex-start;
                        "
                      >
                        <p class="dados_restaurante">Aceitamos:</p>
                        <p
                          class="dados_restaurante"
                          v-for="(forma, index) in formas"
                          :key="index"
                        >
                          {{ forma.nm }},
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container_principal">
                <div ref="marcador" class="marcador"></div>
                <div
                  ref="container_produtos"
                  class="categorias"
                  :style="{ backgroundColor: corFundo }"
                  :class="{ fixado: isActive }"
                >
                  <ol
                    class="container_categorias"
                    v-for="(classe, index) in classe_prods"
                    :key="classe.nm"
                    :id="index"
                    :ref="classe.nm_id"
                  >
                    <li
                      class="cabecalho_categorias"
                      @click="scrollArray(classe.nm_id)"
                    >
                      {{ classe.nm }}
                    </li>
                  </ol>
                </div>

                <ul ref="container_produtos" class="listando_produtos">
                  <li
                    class="categorias_estilo"
                    v-for="(classe, index) in classe_prods"
                    :key="classe.nm"
                    :id="index"
                    :ref="classe.nm_id"
                  >
                    <div class="container_secoes">
                      <div class="container_caixa_titulo">
                        <h2 class="container_titulo">{{ classe.nm }}</h2>
                        <i
                          class="fa fa-list-ul"
                          @click="mudarLista(classe.nm_id)"
                          style="font-size: 25px"
                          aria-hidden="true"
                        ></i>
                      </div>

                      <div class="container_produtos">
                        <ul
                          ref="container_produtos"
                          class="listar_produtos"
                          :class="{ active: classe.nm_id === classeClicada }"
                        >
                          <li
                            class="produtos_listados"
                            v-for="produto in products.filter(
                              (e) => e.classe === classe.nm
                            )"
                            :key="produto.cd"
                            @click="
                              verificaordemprod(
                                produto.cd,
                                produto.nm,
                                produto
                              ),
                                (cdproduto = produto.cd),
                                (nmproduto = produto.nm),
                                (vlproduto = produto.vl),
                                (ingredientesproduto = produto.ingredientes),
                                (classeproduto = produto.classe),
                                listandoordem(
                                  produto.cd,
                                  produto.nm,
                                  produto.classe,
                                  produto.ingrediente,
                                  produto.vl,
                                  nome_ordem.cd,
                                  nome_ordem.cd_prod,
                                  nome_ordem.nm,
                                  nome_ordem.ordem,
                                  nome_ordem.selecao
                                )
                            "
                          >
                            <div class="caixa_produto">
                              <img
                                class="estilo_imagem"
                                v-bind:src="
                                  urlImageProduto(retornaContrato, produto.cd)
                                "
                                v-bind:alt="produto.cd"
                                @error="erroImagemProduto"
                                @waiting="urlImageProduto"
                                loading="lazy"
                              />

                              <div class="descricao_produto">
                                <h3 class="nome_card_produto">
                                  {{ produto.nm }}
                                </h3>
                                <p
                                  class="caixa_desc_produto"
                                  style="margin-bottom: 0"
                                >
                                  {{ produto.ingredientes }}
                                </p>
                                <b class="agrupamento_valores">
                                  <div
                                    class="promo-price css_mobile_preco"
                                    v-if="
                                      produto.vl_promo > 0 &&
                                      produto.classe.toUpperCase() !== 'PIZZAS'
                                    "
                                  >
                                    <p
                                      class="risquinho"
                                      style="font-size: 13px"
                                    >
                                      R$ {{ produto.vl }}
                                    </p>
                                    <p class="valor_produto">
                                      R$ {{ produto.vl_promo }}
                                    </p>
                                    <!-- valor de promoção -->
                                  </div>
                                  <p class="valor_produto" v-else>
                                    R$ {{ produto.vl }}
                                  </p>
                                </b>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <a
          class="botao-vai-topo btn btn-dark"
          id="irTopo"
          @click="scrollMeTo('topo')"
          style="background-color: gray; z-index: 11"
        >
          Topo
        </a>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Inis from "../services/inis";
import Classe_prod from "../services/classe_prod";
import Ordem from "../services/nome_ordem";
import SecureLS from "secure-ls";
import Horario from "../services/horario";
import Bandeira from "../services/bandeira";
import { ref } from "vue";
var ls = new SecureLS({ encodingType: "aes" });

export default {
  name: "Products",
  data() {
    return {
      checkedNames: [],
      adicionaispergunta: [],
      search: "",
      classe_prods: [],
      classe_prod: {
        nm: "",
        ordem: "",
      },
      product: {
        cd: "",
        nm: "",
        classe: "",
        ingredientes: "",
        vl: "",
      },
      nome_ordens: [],
      nome_ordem: {
        cd: "",
        nm: "",
        ordem: "",
        cd_prod: "",
        selecao: "",
      },
      //adicionais: [],
      adicional: {
        cd: "",
        cd_prod: "",
        qtd: "",
        vl: "",
        tipo: "",
        nm: "",
        cd_sabor: "",
        ordem: "",
        obs: "",
        cd_prod_pai: "",
      },
      corBotao: "",
      corTexto: "",
      corFundo: "",
      corClasse: "",
      corDescricao: "",
      cdproduto: "",
      nmproduto: "",
      vlproduto: "",
      ingredientesproduto: "",
      classeproduto: "",
      index: 0,
      classes: [],
      classesNomes: [],
      classesNomes2: [],
      mostrarProduto: false,
      classeClicada: "",
      arrayMostrarProduto: [],
      errosImagem: [],
      contrato: "",
      estoque: "",
      ordemAlfabetica: 0,
      horarios: [],
      formas: [],
      estabelecimento: [],
      whatsapp: [],
      endereco: [],
      tipo_estabelecimento: [],
      isActive: false,
      elementOffSet: 0,
    };
  },
  computed: {
    retornaContrato() {
      this.contrato = localStorage.getItem("contrato");
      return this.contrato;
    },
    ...mapGetters({
      //adicionais: 'allAdicionais',
      products: "allProducts",
      length: "getNumberOfProducts",
    }),
    //pesquisar QRCODE
  },
  methods: {
    urlImage(contrato, classe) {
      let encodedNm = Buffer.from(classe).toString("base64");
      return `https://apppanterafood.com.br/DeliveryCenter/${contrato}/classes/${encodedNm}.jpg?${performance.now()}`;
    },
    urlImageProduto(contrato, prod) {
      let encodedNm = Buffer.from(prod).toString("base64");
      return `https://apppanterafood.com.br/DeliveryCenter/${contrato}/produtos/${prod}.jpg?${performance.now()}`;
    },
    verificaordemprod(cd, nm, product) {
      Ordem.verificaordem(cd).then((resposta) => {
        if (product.classe.toUpperCase() == "PIZZAS") {
          ls.set(
            "product" + localStorage.getItem("contrato"),
            JSON.parse(JSON.stringify(product))
          );
          this.$router.push("/perguntaspizza");
        } else if (resposta.data === null || resposta.data.length == 0) {
          //alert(JSON.stringify(product));

          if (product.vl_promo > 0) {
            product.vl = product.vl_promo;
          }
          ls.set(
            "product" + localStorage.getItem("contrato"),
            JSON.parse(JSON.stringify(product))
          );
          this.$router.push("/produtounico");
        } else {
          if (product.vl_promo > 0) {
            product.vl = product.vl_promo;
          }
          ls.set(
            "product" + localStorage.getItem("contrato"),
            JSON.parse(JSON.stringify(product))
          );

          this.$router.push("/perguntas");
        }
      });
    },
    categoriaFixado() {
      this.isActive =
        document.querySelector("#secondaryBody").scrollTop > this.elementOffSet;
    },
    scrollMeTo(refName) {
      var element = this.$refs[refName];

      var top = element.offsetTop;

      element.scrollIntoView({ behavior: "smooth" });
    },
    scrollArray(refName) {
      var element = this.$refs[refName];

      element[1].scrollIntoView({ behavior: "smooth" });
    },
    listarclasse() {
      Classe_prod.listarclasse().then((resposta) => {
        this.classe_prods = resposta.data;
        this.classe_prods.map((classe) => {
          var id;
          id = classe.nm;
          id = id.replace(/[áàãâä]/iu, "a");
          id = id.replace(/[éèêë]/iu, "e");
          id = id.replace(/[íìîï]/iu, "i");
          id = id.replace(/[óòõôö]/iu, "o");
          id = id.replace(/[úùûü]/iu, "u");
          id = id.replace(/[ç]/iu, "c");
          id = id.replace(/[^a-zA-Z 0-9]+/g, "");
          id = id.replace(/_+/, "");
          id.toUpperCase();

          classe.nm_id = id;
        });
      });
    },

    erroImagemProduto(event) {
      event.target.src =
        "https://apppanterafood.com.br/DeliveryCenter/" +
        this.retornaContrato +
        "/produtos/sem_imagem.jpg";
    },
    erroImagem(e) {
      var classe = e.target.id;

      document.querySelector("." + classe.split(" ").join("")).remove();

      /* activeDiv.classList.add('hidden'); */
    },
    listandoInis() {
      var cd = "CONTROLA_ESTOQUE";
      Inis.listarInisCd(cd).then((resposta) => {
        this.estoque = resposta.data[0].vl;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corTexto = resposta.data[0].vl;
      });
      var cd = "COR_CLASSE";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corClasse = resposta.data[0].vl;
      });
      var cd = "COR_DESCRICAO ";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corDescricao = resposta.data[0].vl;
      });
      var cd = "ID_PIXEL";
      Inis.listarInisCd(cd).then((resposta) => {
        const idPixel = resposta.data[0].vl;
        this.loadFacebookPixel(idPixel);
      });
      var cd = "ORDEM_ALFABETICA";
      Inis.listarInisCd(cd).then((response) => {
        this.ordemAlfabetica = response.data[0].vl;
      });
    },
    mudarLista(classeId) {
      // Atualiza a classe clicada
      this.classeClicada = classeId;
    },
    listandoordem(ord) {
      Ordem.listandoordem(ord).then((resposta) => {
        this.nome_ordens = resposta.data;
      });
    },
    listar() {
      if (
        this.$route.query.serie != undefined &&
        this.$route.query.num_serie != undefined
      ) {
        localStorage.setItem(
          "serie" + localStorage.getItem("contrato"),
          this.$route.query.serie
        );
        localStorage.setItem(
          "num_serie" + localStorage.getItem("contrato"),
          this.$route.query.num_serie
        );
      }

      this.$store.dispatch("fetchProducts", { self: this });
    },
    loadFacebookPixel(idPixel) {
      // Crie o elemento <script> para carregar o Pixel
      var script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      script.async = true;

      // Adicione o Pixel ID à chamada de inicialização do Pixel
      var initCode = 'fbq("init", "' + idPixel + '");';

      // Crie o elemento <noscript> para o caso de o usuário não ter JavaScript habilitado
      var noscript = document.createElement("noscript");
      var img = document.createElement("img");
      img.height = 1;
      img.width = 1;
      img.style.display = "none";
      img.src =
        "https://www.facebook.com/tr?id=" + idPixel + "&ev=PageView&noscript=1";

      // Adicione o código de inicialização ao elemento <noscript>
      noscript.appendChild(document.createTextNode(initCode));
      noscript.appendChild(img);

      // Adicione os elementos ao DOM
      document.head.appendChild(script);
      document.head.appendChild(noscript);
    },
    ...mapActions(["addToCart"]),
    handleScroll() {
      // Comparar com a posição calculada
      this.isFixed = window.scrollY >= this.offsetTop;
    },
    updateOffsetTop() {
      // Atualizar o offset com base no conteúdo atual
      this.$nextTick(() => {
        this.offsetTop = this.$refs.container_produtos.offsetTop;
      });
    },

    async listarHorarios() {
      var ativo = 1;
      await Horario.listarhorario(ativo).then((resposta) => {
        this.horarios = resposta.data;
        console.log(this.horarios);
      });
    },
    async listarForma() {
      await Bandeira.listarbandeiras().then((resposta) => {
        this.formas = resposta.data;
      });
    },
    async listarEstabelecimento() {
      var cd = "ESTABELECIMENTO";
      await Inis.listarInisCd(cd).then((resposta) => {
        this.estabelecimento = resposta.data[0];
      });
    },
    async listarWhatsapp() {
      var cd = "WHATSAPP";
      await Inis.listarInisCd(cd).then((resposta) => {
        this.whatsapp = resposta.data[0];
      });
    },
    async listarEndereco() {
      var cd = "ENDERECO";
      await Inis.listarInisCd(cd).then((resposta) => {
        this.endereco = resposta.data[0];
      });
    },
    async listarTipoEstabelecimento() {
      var cd = "TIPO_ESTABELECIMENTO";
      await Inis.listarInisCd(cd).then((resposta) => {
        this.tipo_estabelecimento = resposta.data[0];
      });
    },
    retornaDias(index) {
      var dias = this.horarios[index].dias
        .replace("seg", " Seg")
        .replace("ter", " Ter")
        .replace("qua", " Qua")
        .replace("qui", " Qui")
        .replace("sex", " Sex")
        .replace("sab", " Sáb")
        .replace("dom", " Dom");
      return dias;
    },
  },
  mounted() {
    this.listandoInis(),
      this.listar(),
      this.listarclasse(),
      this.listandoordem();
    this.listarHorarios();
    this.listarForma();
    this.listarWhatsapp();
    this.listarEndereco();
    this.listarEstabelecimento();
    this.listarTipoEstabelecimento();

    this.$nextTick(() => {
      if (this.$refs.container_produtos) {
        this.elementOffSet = this.$refs.container_produtos.offsetTop;
      }
    });

    document
      .querySelector("#secondaryBody")
      .addEventListener("scroll", this.categoriaFixado);
  },
};
</script>
<style scoped>
body {
  scrollbar-width: none;
}

.promo-price {
  font-weight: bold; /* negrito, se desejar */
}

.risquinho {
  text-decoration: line-through;
  color: Gray;
}

.valor_produto {
  color: #df0000;
  font-size: 16px;
}

.produtos_listados {
  height: 300px;
}

.agrupamento_valores {
  display: flex;
  align-items: center;
  justify-content: center;
}

.css_mobile_preco {
  width: fit-content;
  height: fit-content;

  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 0.25em;
}

.active {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1em;
}

.imagem_logotipo {
  width: 75px;
  height: 75px;
}

.cabecalho_restaurante {
  padding: 0.5em 0 0.5em 0.5em;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 1em;
}

.informacoes_restaurante {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.nome_restaurante {
  font-size: 18px;
  color: #000;
  font-weight: bold;
}

.dados_restaurante {
  font-size: 12px;
  color: #747473;
  font-weight: bold;
}

.botao-vai-topo {
  position: fixed;
  bottom: 30px;
  right: 20px;
  color: #fff !important;
}

.banner {
  height: 125px;
}

.div_banner-cabecalho {
  justify-content: center;
  display: flex;
  flex-flow: row nowrop;
  align-items: center;
  flex-direction: column;

  margin: 0 0 1em 0;
}

.container_principal {
  padding: 0;
  overflow: visible;
  height: fit-content;
}

.categorias {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 0.5em;

  padding: 10px 0.5em;

  overflow-x: auto; /* Habilita o scroll horizontal */
  scroll-snap-type: x mandatory; /* Ajusta para snapping de itens */

  scrollbar-width: none;
  cursor: pointer;
  z-index: 12 !important;
  -webkit-transform: translate3d(0, 0, 1px);
  transform: translate3d(0, 0, 1px);
}

.categorias.fixado {
  position: fixed;
  top: 0;
  right: 0;
  border-bottom: #000 1px solid;
  z-index: 12 !important;
}

.cabecalho_categorias {
  width: max-content;

  background-color: #fff;
  font-size: 16px;
  font-weight: 500;

  border: #000 solid 1px;
  padding: 0.5em;
  border-radius: 0.5em;

  cursor: pointer;
}

.container_categorias {
  display: flex;
  flex-direction: row;
  gap: 1em;
  align-items: center;

  margin: 0;
}

.container_secoes {
  display: flex;
  flex-direction: column;
  padding: 0 0.5em;
}

.listar_produtos {
  display: flex;
  flex-direction: row;
  width: 100%;

  padding-bottom: 0.25em;

  transition: width 1s, height 1s;

  overflow-x: auto; /* Habilita o scroll horizontal */
  scroll-snap-type: x mandatory; /* Ajusta para snapping de itens */
  -webkit-overflow-scrolling: touch;

  scrollbar-width: none;
}

.container_produtos {
  display: flex;
  flex-direction: row;
  width: 100%;
  z-index: 10;
}

.container_caixa_titulo {
  background-color: #f5f5f5;
  width: fit-content;
  margin: 1em 0;
  padding: 0.5em;
  border-radius: 0.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
  z-index: 10;
}

.container_titulo {
  font-size: 25px;
  color: #000;
  font-weight: bold;
}

.caixa_produto {
  border: 1px black solid;
  border-radius: 0.5em;
  background-color: #fff;
  width: 100%;
  height: 100%;

  margin: 0 5px;

  display: grid;
  grid-template-rows: 40% 60%;
  grid-column-gap: 1%;

  width: 11em;

  cursor: pointer;
}

.estilo_imagem {
  width: 100%;
  height: 100%;
  padding: 0.25em 0.25em;
  border-radius: 0.5em;
}

.descricao_produto {
  font-family: Roboto, -apple-system, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  display: grid;
  grid-template-rows: 20% 60% 20%;
  width: 100%;
  padding: 0.25em;
  text-align: center;
}

.nome_card_produto {
  font-weight: bold;
  font-size: 14px;
  color: black;

  display: flex;
  justify-content: center;
  align-items: center;
}

.caixa_desc_produto {
  overflow: hidden;
  color: #000;
  text-align: center;
  font-size: 10px;
  font-family: Roboto, -apple-system, Helvetica Neue, Helvetica, Arial,
    sans-serif;
}

@media (min-width: 1300px) {
  .listar_produtos {
    display: grid;
    grid-template-columns: 49.5% 49.5%;
    grid-row-gap: 1em;
    grid-column-gap: 1%;
  }

  .produtos_listados {
    height: fit-content;
  }

  .agrupamento_valores {
    justify-content: flex-start;
    align-items: center;
  }

  .css_mobile_preco {
    flex-direction: row;
    gap: 0.5em;
  }

  .nome_card_produto {
    justify-content: flex-start;
    align-items: center;
  }

  .banner {
    width: 100%;
    height: 400px;
  }

  .imagem_logotipo {
    width: 100px;
    height: 100px;
  }

  .active {
    flex-direction: none;
  }

  .container_secoes {
    padding: 0;
  }

  .caixa_produto {
    width: 100%;
    height: 200px;

    margin: 0;

    display: flex;
    flex-direction: row;

    border-color: #747473;
  }

  .caixa_produto:hover {
    border-color: #545454;
    box-shadow: #2c2c2c 1px 1px;
    transition: 1s;
  }

  .estilo_imagem {
    width: 40%;
    height: 100%;
  }

  .descricao_produto {
    width: 80%;
    height: 100%;

    display: grid;
    grid-template-rows: 15% 65% 20%;
  }

  .categorias {
    padding: 0.5em;
    scrollbar-width: auto;
  }

  .caixa_desc_produto {
    display: flex;
    font-size: 12px;
    justify-content: flex-start;
    align-items: center;
    text-align: start;
  }
}
</style>
